import styled, { CSSObject } from '@emotion/styled';
import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../store';
import { employeeListActions } from '../../store/entities/employeeList';
import { downloadBlob } from '../../utils/download';
import { QcsLoadingButton } from '../common/basic/QcsLoadingButton';
import { employeeService } from '@api/services/services';

const EmployeeImportExportContainer = styled.div(
  (): CSSObject => ({
    display: 'flex',
    gap: '0.5rem',
    marginTop: '-0.5rem',
    marginBottom: '1rem',
    marginLeft: 'auto',
  }),
);

export const EmployeeImportExport: FC = () => {
  const { t } = useTranslation();
  const fileRef = useRef<HTMLInputElement>(null);
  const dispatch = useAppDispatch();

  const handleImport = () => {
    fileRef.current?.click();
  };

  const handleFileChange = async (files: FileList | null) => {
    if (!files) return;

    const file = files[0];
    await employeeService.importEmployees(file);
    dispatch(dispatch(employeeListActions.reload(true)));
    if (fileRef.current) fileRef.current.value = '';
  };

  const handleExport = async () => {
    const response = await employeeService.exportEmployees();
    await downloadBlob(response);
  };

  return (
    <EmployeeImportExportContainer>
      <input ref={fileRef} hidden type="file" onChange={({ target }) => handleFileChange(target.files)} />
      <QcsLoadingButton variant="outlined" onClick={handleImport}>
        {t('employee.import')}
      </QcsLoadingButton>
      <QcsLoadingButton variant="outlined" onClick={handleExport}>
        {t('employee.export')}
      </QcsLoadingButton>
    </EmployeeImportExportContainer>
  );
};
